export default "__VITE_ASSET__D1kvxt7I__"